// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"dc9173c9f5dec2042084","731":"d678b0d21f8b5d5184a2","843":"5abd4a2b6d58982a8e08","883":"b8b0d36510ae4fa3e97b"}[chunkId] + ".js";
};